import React from 'react';
import { MapPin, Clock, Phone, ExternalLink } from 'lucide-react';

const GoogleMapLocator = ({ className = '', style = {} }) => {
  const handleDirections = () => {
    window.open('https://www.google.com/maps/dir//26.9147117,75.700359', '_blank');
  };

  const handlePlaceDetails = () => {
    window.open('https://maps.google.com/?cid=ChIJ7dFNzn9NbDkRkm4cmr0t3XE', '_blank');
  };

  return (
    <div 
      className={className}
      style={{
        width: '100%',
        height: '500px',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
        position: 'relative',
        ...style
      }}
    >
      {/* Google Maps Embed */}
      <iframe 
        src="https://storage.googleapis.com/maps-solutions-0xgnuljujz/locator-plus/yufr/locator-plus.html"
        width="100%" 
        height="80%" 
        style={{
          border: 0,
          borderRadius: '16px 16px 0 0'
        }} 
        loading="lazy"
        title="B.Tech Bawarchi Location"
      />
      
      {/* Location Info Overlay */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '20%',
        background: 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: window.innerWidth <= 768 ? '12px 16px' : '16px 20px',
        borderRadius: '0 0 16px 16px'
      }}>
        {/* Location Details */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flex: 1
        }}>
          <div style={{
            backgroundColor: '#ff6b35',
            borderRadius: '8px',
            padding: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <MapPin size={16} color="white" />
          </div>
          <div>
            <h4 style={{
              fontSize: window.innerWidth <= 768 ? '14px' : '16px',
              fontWeight: '700',
              color: '#1f2937',
              margin: '0 0 4px 0',
              lineHeight: '1.2'
            }}>
              B.Tech Bawarchi
            </h4>
            <p style={{
              fontSize: '12px',
              color: '#6b7280',
              margin: 0,
              lineHeight: '1.3'
            }}>
              KanakVrindvan Township, Jaipur
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          gap: '8px'
        }}>
          <button
            onClick={handleDirections}
            style={{
              backgroundColor: '#22c55e',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 12px',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#16a34a';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#22c55e';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <Clock size={12} />
            Directions
          </button>
          
          <button
            onClick={handlePlaceDetails}
            style={{
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 12px',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2563eb';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#3b82f6';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <ExternalLink size={12} />
            View
          </button>
        </div>
      </div>
    </div>
  );
};

export default GoogleMapLocator;
